import request from "@/utils/request";

// 列表(主数据列表)
export function loadStoreListDataApi(data) {
  return request({
    url: "web/storeInfo/listData",
    method: "post",
    data
  });
}
// 导出
export function loadStoreExportDataApi(data) {
  return request({
    url: "web/storeInfo/exportData",
    method: "post",
    data
  });
}
// 导出走访维护工作表
export function loadStoreExportVisitWorkTableApi(data) {
  return request({
    url: "web/storeInfo/exportVisitWorkTable",
    method: "post",
    data
  });
}
// 导出走访维护计划表
export function loadStoreExportVisitPlanWorkTableApi(data) {
  return request({
    url: "web/storeInfo/exportVisitPlanWorkTable",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateStoreApi(data) {
  return request({
    url: "web/storeInfo/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initStoreApi(data) {
  return request({
    url: "web/storeInfo/initStoreInfo",
    method: "post",
    data
  });
}

// 同步钉钉ID
export function updateStoreDingInfoApi(data) {
  return request({
    url: "web/storeInfo/updateStoreDingInfo",
    method: "post",
    data
  });
}

// 导出钉钉模板
export function exportStoreDingDataApi(data) {
  return request({
    url: "web/storeInfo/exportStoreDingData",
    method: "post",
    data
  });
}

// 零售户列表（下拉选择）
export function getStoreListApi(data) {
  return request({
    url: "web/storeInfo/listSelectData",
    method: "post",
    data
  });
}

// 零售户拜访线路（下拉选择）
export function getStoreVisitLineListApi(data) {
  return request({
    url: "web/storeInfo/listSelectVisitLineData",
    method: "post",
    data
  });
}

// 根据地址获取坐标
export function getLocationByAddressApi(data) {
  return request({
    url: "web/storeInfo/getLocationByAddress",
    method: "post",
    data
  });
}

// 根据条件获取重复数据
export function getDoubleInfoByConditionApi(data) {
  return request({
    url: "web/storeInfo/getDoubleInfoByCondition",
    method: "post",
    data
  });
}

// 根据条件获取数据
export function getStoreInfoByConditionApi(data) {
  return request({
    url: "web/storeInfo/getStoreInfoByCondition",
    method: "post",
    data
  });
}

// 根据条件获取品鉴和圈层数据
export function findTasteAndCrossInfoByStoreApi(data) {
  return request({
    url: "web/storeInfo/findTasteAndCrossInfoByStore",
    method: "post",
    data
  });
}


// 根据零售户ID查询零售监测设置
export function findStoreInfoCollectSettingByStoreIdApi(data) {
  return request({
    url: "web/storeInfoCollectSetting/findSettingByStoreId",
    method: "post",
    data
  });
}

// 保存采集设置信息
export function saveOrUpdateStoreInfoCollectSettingApi(data) {
  return request({
    url: "web/storeInfoCollectSetting/saveOrUpdate",
    method: "post",
    data
  });
}